export default function ChromePointer() {
  return (
    <div
      style={{
        width: '12px',
        height: '12px',
        'border-radius': '6px',
        transform: 'translate(-6px, -1px)',
        'background-color': 'rgb(248, 248, 248)',
        'box-shadow': '0 1px 4px 0 rgba(0, 0, 0, 0.37)',
      }}
    />
  )
}
